import { isMobile } from "react-device-detect"
import { useEffect, useState } from "react";
//icons
import { IoMdArrowDown } from "react-icons/io";
import { imagenesAll } from "../asset/img";
import { BeforeFooterDekstop, BeforeFooterMobile, EmpityBox, IsMobileHeader, IsPcHeader } from "../componentes/Principales";
import { useNavigate } from "react-router-dom";

export const Home =()=>{
  return(
    <>
      {isMobile ? <HomeMobile /> : <HomeDesktop /> }
    </>
  )
}

export const HomeDesktop  =()=>{
  const [imgHover, setImgHover] = useState(imagenesAll.vServicioPageMarketing);
  const [isFading, setIsFading] = useState(false);
  const navigate = useNavigate();
  const handleHover = (newImage) => {
    setIsFading(true);
    setTimeout(() => {
      setImgHover(newImage);
      setIsFading(false);
    }, 400); // mismo tiempo que la transición del CSS
  };
  useEffect(() => {
    document.title = "WAZ Experience - Inicio";
  }, []);
  return(
    <div className="m_bg_f2f2f2 w-100">
      <div className="m_bg_secondary m_bg_headerHome">
        <div className="">
          <IsPcHeader imgUrlWaz={imagenesAll.logoWazBlanco} />
          <div className="m_h100vh w-100 m_text_primary m_font_primary d-flex flex-column justify-content-center align-items-center">
            <div className="">
              <p className="m_h1 m_text_white m-0">Moviendo marcas,<br></br>creando impacto</p>
            </div>
              <p className="m_bl fs-4 mt-5">Destácate de la competencia con marketing experience</p>
          </div>
        </div>
      </div>
      {/* servicios*/}
      <section className="w-100 my-5 py-4 position-relative">
        <img
          className="ma_imgCard_service"
          src={imgHover}
          alt="waves"
          style={{ opacity: isFading ? 0 : 1 }}
        />
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div>
                <span className="m_bg_amarillo py-1 px-2 rounded-3 m_text_secondary">TAKE A LOOK</span>
                <h3 className="m_text_secondary m_h1">Nuestros <br /> Servicios</h3>
              </div>
            </div> 

            <div className="col-md-4 ma_animacion_all">
              <div
                onMouseEnter={() => handleHover(imagenesAll.vServicioPageMarketing)}
                onMouseLeave={() => handleHover(imagenesAll.vServicioPageMarketing)}
              >
                <CardHover title="MARKETING DIGITAL" text1="Estrategia de comunicación" text2="Estrategia de email marketing" text3="Contenido para redes sociales" />
              </div>

              <div
                onMouseEnter={() => handleHover(imagenesAll.vServicioPageGrowth)}
                onMouseLeave={() => handleHover(imagenesAll.vServicioPageMarketing)}
              >
                <CardHover title="GROWTH Y PAUTA PUBLICITARIA" text1="Estrategia de pauta" text2="Configuración de cuentas" text3="Creatividades" text4="Reportes" />
              </div>

              <div
                onMouseEnter={() => handleHover(imagenesAll.vServicioPageBranding)}
                onMouseLeave={() => handleHover(imagenesAll.vServicioPageMarketing)}
              >
                <CardHover title="BRANDING" text1="Identidad visual" text2="Rebranding" text3="Sistema gráfico" text4="Manual de identidad" />
              </div>

              <div
                onMouseEnter={() => handleHover(imagenesAll.vServicioPageDesarrollo)}
                onMouseLeave={() => handleHover(imagenesAll.vServicioPageMarketing)}
              >
                <CardHover title="DESARROLLO WEB" text1="E-commerce" text2="Apps móviles" text3="Diseño UX/UI" text4="Wireframing" />
              </div>

              <div
                onMouseEnter={() => handleHover(imagenesAll.vServicioPageEventos)}
                onMouseLeave={() => handleHover(imagenesAll.vServicioPageMarketing)}
              >
                <CardHover title="EVENTOS" text1="Cobertura de eventos" text2="Activaciones" text3="Experiencias" text4="Eventos internos" />
              </div>
            </div>

            <div className="d-flex align-items-around justify-content-around ">
              <EmpityBox />
              <EmpityBox />
              <button
                onClick={() => navigate("/contacto")}
                className="border-0 rounded-2 m_bg_orange ma_home_btn_servicios mt-3 m_text_white px-3 py-2 fs-4"
              >
                Me interesa
              </button>
              <EmpityBox />
            </div>
          </div>
        </div>
      </section>
     {/* ofrecemos*/} 
     <div className="ma_home_ofrecerServicio w-100">
     <section className="container mt-5  pt-5 ">
      <div className="row">
        <div className="text-end">
          <span className="m_bg_amarillo py-1 px-3 ">Take a look</span>
            <p className="m_text_orange m_hs fs-3">¿Qué nos convierte en tu <br></br> mejor socio de marketing?</p> 
        </div> 
      </div>
      <div className="row">
        <div className="col-md-7">
          <p className="m_text_secondary fs-3 mt-5 pt-5">Lo que ofrecemos te ayuda a <span><IoMdArrowDown className="m_text_rosa"/></span></p>
          <div className="">
              <OfrecemosCard imgUrl={imagenesAll.phone} text={"Hacer más eficientes tus inversiones de marketing, comunicación y promoción."}/>
              <OfrecemosCard imgUrl={imagenesAll.dobleDialogo} text={"Alcanzar relaciones únicas y duraderas, con tus clientes, tu organización y el mercado."}/>
              <OfrecemosCard imgUrl={imagenesAll.flechasTodasDireccion} text={"Aumentar el valor de tu marca."} />
          </div>
        </div>
      </div>

     </section>
     </div>
     <section className="w-100 container">
      <div className="row">
        <div className="col-lg-6">
          <div className="">
            <p className="m_text_secondary fs-3 mt-5 pt-5">Y todo eso lo logramos a través de <span><IoMdArrowDown className="m_text_rosa"/></span></p>
          </div>
          <div className="my-4">
            <h5 className="m_text_orange">Transformación inspiradora</h5>
            <p className="m_text_secondary ">No nos gusta quedarnos quietas. Transformamos moviendo marcas.</p>
          </div>
          <div className="my-4">
            <h5 className="m_text_orange">Fusíon creativa-estratégica</h5>
            <p className="m_text_secondary ">Diseñamos campañas y experiencias que no sólo son estéticamente <br></br> impresionantes, sino que abrirán puertas hacia el éxito.</p>
          </div>
          <div className="my-4">
            <h5 className="m_text_orange">Empatía y Compromiso</h5>
            <p className="m_text_secondary ">Tu éxito es el nuestro. Te escuchamos y comprendemos tus objetivos.</p>
          </div>
          </div>
        </div>
      </section>
  {/* portafolio */}
     <section className="container my-5 py-5 w-100">
          <div className="row">
            <div className="col-lg-4 ">
              <div className=""><span className="m_bg_amarillo px-2 m_bs rounded-2 py-1 ">OUR WORK</span></div>
              <p className="m_h2">¿Todavía lo estás dudando?</p>
              <p className="fs-5">Mira con tus propios ojos las marcas que acompañamos, las marcas que movimos.</p>
            </div>
            <div className="col-lg-8 m_bg_gradiant_portafolio rounded-3">
              <div className="m-3 pt-4">
                  <span className="m_text_white m_tl">Social Media</span>
                  <div className="d-flex">
                  <CardPortafolioMedia 
                    imgSocialMedia={imagenesAll.imgPortafolioLg1} 
                    altImgSocialMedia={"Digitalizate"} 
                    titleCard={"Ahorra tiempo, dinero y papel en tu empresa"}
                    textCard={"¿Sabías cuánto te cuesta manejar documentos en papel? Digitalizá tus trámites y ganá en eficiencia, control y ahorro. Descubrí cómo con nuestra solución a medida."}
                  />
                
                  <CardPortafolioMedia 
                    imgSocialMedia={imagenesAll.imgPortafolioLg3} 
                    altImgSocialMedia={"Digitalizate"} 
                    titleCard={"Impulsá tu empresa con software a medida"}
                    textCard={"Desarrollar tu propio software te permite tener una solución 100% alineada a tus objetivos. Accedé a tecnología segura, comunicación constante y eficiencia en tiempos y costos. Nos convertimos en tu aliado estratégico para optimizar procesos y hacer crecer tu negocio."}
                  />
                    <CardPortafolioMedia 
                    imgSocialMedia={imagenesAll.imgPortafolioLg2} 
                    altImgSocialMedia={"Digitalizate"} 
                    titleCard={"Llevá tu negocio al mundo online y vendé más"}
                    textCard={"Cada vez más personas compran por internet, y tu negocio no puede quedarse atrás. Con una tienda online podés vender las 24 hs, llegar a más clientes y hacer crecer tus ventas sin límites."}
                  />

                  </div>
                </div>
              </div>
          </div>
        <div className="row">
          <div className="col-lg-6 rounded-3 mt-3" style={{ backgroundColor: '#090E2C' }}>
            <div className="d-flex align-items-center justify-content-around " >
              <img className="rounded-2 w-25" src={imagenesAll.imgPortafolioLg23} alt="Portafolio" />
              <img className="m_w_30" src={imagenesAll.imgPortafolioLg21} alt="Portafolio" />
              <img className="rounded-2 w-25" src={imagenesAll.imgPortafolioLg22} alt="Portafolio" />
            </div>
          </div>
          <div className="col-lg-6">
          <div className="mt-3">
            <div className="">
              <span className="m_text_secondary m_bs">MERCURIO SOFT</span>
              <p className="m_tl p-0 m-0 mt-3">Comunicación en Linkedin & Instagram</p>
              <p className="m_bl p-0 m-0">Conectando con la audencia profesional.</p>
            </div>
            <div className="my-4">
              <p className="m_tl p-0 m-0">Diseño Web Institucional</p>
              <p className="m_bl p-0 m-0">Transformando la presencia en línea</p>
            </div>
            </div>
          </div>
        </div>
      </section>
      <BeforeFooterDekstop className="" text1="¿Te gustaría confirmar" text2="si hacemos match?" textBtn="Contanos tu proyecto" />
    </div>
  )
}
export const HomeMobile  =()=>{
  const navigate = useNavigate();
  return(
    <div className="w-100">
{/* header */}
      <div className="m_bg_secondary">
        <div className=" w-100 m_h100vh flex-column text-center m_bg_headerHomeMobile">
          <IsMobileHeader />
          <div className="empity_box mt-5 pt-5"></div>
          <h3 className="m_h3 m_tl mb-5 m_text_white mt-5 pt-5">Moviendo marcas, <br></br>creando impacto</h3>
          <p className="m_text_primary fs-1 m_bl">Destácate de la<br></br> competencia con <br></br> marketing experience</p>
        </div>
      </div>

{/* nuestros servicios */}
      <section className="w-100 m_dfc">
        <div className="m_w_90">
          <div className="mt-5">
            <span className="m_bg_amarillo mb-4 px-3 rounded-2 m_text_secondary ">TAKE A LOOK</span>
          </div>
          <h3 className="m_text_secondary m_h3">Nuestros <br></br> Servicios</h3>
          <CtnServiciosCard />
          <div className="m_dfc">
            <button onClick={() => navigate("/contacto")} className="border-0 rounded-2 m_bg_orange mt-3 m_text_white px-4 py-3 fs-5">Me interesa</button>
          </div>
        </div>
      </section>

{/* Ofrecer ayuda */}
      <section className="ma_prueba_group m_dfc">
        <div className="m_w_90">
          <div className="mt-3 pt-3 ">
            <div className="mt-5 mb-4 w-100 d-flex align-items-end flex-column">
              <span className="m_text_secondary m_bg_amarillo px-2 py-1 rounded-2 fs-4 mb-3">TAKE A LOOK</span>
              <p className="m_text_orange fs-1 text-end mt-3">¿Qué nos convierte <br></br> en tu mejor socio de<br></br> marketing? </p>
            </div>
          </div>

          <div className="">
            <p className="m_text_secondary fs-1">Lo que te ofrecemos <br></br> te ayuda a</p>
              <div className="">
                <OfrecemosCard imgUrl={imagenesAll.phone} text={"Hacer más eficientes tus inversiones de marketing, comunicación y promoción."}/>
                <OfrecemosCard imgUrl={imagenesAll.dobleDialogo} text={"Alcanzar relaciones únicas y duraderas, con tus clientes, tu organización y el mercado."}/>
                <OfrecemosCard imgUrl={imagenesAll.flechasTodasDireccion} text={"Aumentar el valor de tu marca."} />
              </div>
          </div>
        </div>
      </section>

{/*Logramos*/}
      <section className="w-100 m_dfc">
        <div className="m_w_90">
          <div className="">
            <p className="m_text_secondary fs-3 mt-3 pt-3">Y todo eso lo logramos <br/> a través de <span><IoMdArrowDown className="m_text_rosa"/></span></p>
          </div>
          <div className="my-4">
            <h5 className="m_text_orange">Transformación inspiradora</h5>
            <p className="m_text_secondary ">No nos gusta quedarnos quietas. Transformamos moviendo marcas.</p>
          </div>
          <div className="my-4">
            <h5 className="m_text_orange">Fusíon creativa-estratégica</h5>
            <p className="m_text_secondary ">Diseñamos campañas y experiencias que no sólo son estéticamente impresionantes, sino que te abrirán hacia el éxito.</p>
          </div>
          <div className="my-4">
            <h5 className="m_text_orange">Empatía y Compromiso</h5>
            <p className="m_text_secondary ">Tu éxito es el nuestro. Te escuchamos y comprendemos tus objetivos.</p>
          </div>
        </div>
      </section>

      <div className="w-100 d-flex align-items-center justify-content-center">
        <div className="m_w_90 d-flex flex-column">
         
         


          <div className="mt-3 pt-3">
            <div className="mb-3">
              <span className="m_bg_amarillo px-3 py1 fs-5 rounded-2">OUR WORK</span>
            </div>
            <p className="fs-1">¿Todavía lo estas <br></br> dudando?</p>
            <p className="fs-2">Mira con tus propios ojos las marcas que acompañamos, las marcas que movimos.</p>
          </div>

          <div className="1-100 m_dfc flex-column mt-5 pt-5">
        
        <div className="m_w_90">
        <div className="m_ctn_extended_proyecto1_home_mobile mb-5 pb-5 d-flex">

        <div className="me-2 ">
          <div className="m_bg_gradiant_portafolio rounded-3" style={{ height: "650px", width:"800px" }}>
            <div className=" pt-4">
              <span className="m_text_white m_tl">Social Media</span>
              <div className="d-flex">
                <CardPortafolioMediaMobile
                  imgSocialMedia={imagenesAll.imgPortafolioLg1} 
                  altImgSocialMedia={"Digitalizate"} 
                  titleCard={"Ahorra tiempo, dinero y papel en tu empresa"}
                  textCard={"¿Sabías cuánto te cuesta manejar documentos en papel? Digitalizá tus trámites y ganá en eficiencia, control y ahorro. Descubrí cómo con nuestra solución a medida."}
                />
                 <CardPortafolioMediaMobile
                  imgSocialMedia={imagenesAll.imgPortafolioLg3} 
                  altImgSocialMedia={"Digitalizate"} 
                  titleCard={"Impulsá tu empresa con software a medida"}
                  textCard={"Desarrollar tu propio software te permite tener una solución 100% alineada a tus objetivos. Accedé a tecnología segura, comunicación constante y eficiencia en tiempos y costos. Nos convertimos en tu aliado estratégico para optimizar procesos y hacer crecer tu negocio."}
                />
                <CardPortafolioMediaMobile
                  imgSocialMedia={imagenesAll.imgPortafolioLg2} 
                  altImgSocialMedia={"Digitalizate"} 
                  titleCard={"Llevá tu negocio al mundo online y vendé más"}
                  textCard={"Cada vez más personas compran por internet, y tu negocio no puede quedarse atrás. Con una tienda online podés vender las 24 hs, llegar a más clientes y hacer crecer tus ventas sin límites."}
                />
               
              </div>
            </div>
          </div>
          <div className="mt-2">
            <p className="m_text_secondary"> MERCURIO SOFT</p>
            <p className="m_hm">Comunicación en<br></br>Linkedin & Instagram</p>
            <p className="m_bs fs-3">Conectando con la<br></br> audiencia profecional.</p>
          </div>
        </div>

        <div className="ms-2 " >
          <div className="d-flex align-items-center justify-content-around rounded-3" style={{  height: "650px", width:"800px", backgroundColor: '#090E2C'}}>
            <img className="rounded-2 w-25" src={imagenesAll.imgPortafolioLg23} alt="Portafolio" />
            <img className="m_w_30" src={imagenesAll.imgPortafolioLg21} alt="Portafolio" />
            <img className="rounded-2 w-25" src={imagenesAll.imgPortafolioLg22} alt="Portafolio" />
          </div>
          <div className="mt-2">
            <p className="m_text_secondary"> MERCURIO SOFT</p>
            <p className="m_hm">Diseño Web<br></br>Institucional</p>
            <p className="m_bs fs-3">Transformando la<br></br> presencia en línea.</p>
          </div>
        </div>

        </div>
        </div>
      </div>
        </div>
      </div>

      <BeforeFooterMobile text1="¿Te gustaría" text2="confirmar si" text3="hacemos match" textBtn="Contanos tu proyecto." />
    </div>
  )
}


// componentes

const OfrecemosCard =({imgUrl, text})=>{
  return(
    <div className="d-flex">
      <div className="m_card_ofrecer rounded-3 my-3 d-flex justify-content-center align-items-center">
        <img className="w-75 p-3" src={imgUrl} alt="" />
      </div>
      <div className="ms-3 d-flex justify-content-start align-items-center m_w_60">
        <p className="m_text_orange  m_ts ms-2">{text}</p>
      </div>
    </div>
  )
}
export const CardPortafolioMedia =({imgSocialMedia, altImgSocialMedia, titleCard , textCard})=>{
  return(
    <div className="d-flex flex-column m_text_white mx-2 pb-4 w-50">
      <img className="m_w_20 my-3" src={imagenesAll.iconLinkedin} alt="Icono Linkedin png" />
      <img className="rounded-3 w-100" src={imgSocialMedia} alt={altImgSocialMedia} />
      <p className="m_bl m-0 mt-2 fw-bold">{titleCard}</p>
      <p className="m_bs fs-6 mt-1">{textCard}</p>
    </div>
  )
}
export const CardPortafolioMediaMobile =({imgSocialMedia, altImgSocialMedia, titleCard , textCard})=>{
  return(
    <div className="d-flex flex-column  mx-2 pb-4 w-100 m_cardMobile_ctn_h">
      <img className="m_w_20 my-3" src={imagenesAll.iconLinkedin} alt="Icono Linkedin png" />
      <img className="rounded-3 w-100" src={imgSocialMedia} alt={altImgSocialMedia} />
      <p className="m_bl m-0 mt-2 fw-bold m_text_white">{titleCard}</p>
      <p className="m_bs fs-6 mt-1 m_text_white_v2">{textCard}</p>
    </div>
  )
}

const CtnServiciosCard =()=>{
  const [openBlock, setOpenBlock] = useState(null); // Estado que controla qué bloque está abierto

  const marketingDigitalItems = [
    "Estrategia de comunicación",
    "Estrategia de email marketing",
    "Contenido para redes sociales",
  ];

  const growthItems = [
    "Estrategia de pauta",
    "Creación y configuración de cuentas",
    "Creatividades y copys para pauta",
    "Reportes: Insight y analytics",
  ];

  const brandingItems = [
    "Identidad visual de marca",
    "Rebranding",
    "Sistema gráfico de marca",
    "Manual de identidad",
  ];

  const desarrolloWebItems = [
    "Desarrollo de e-commerce y sitios web",
    "Desarrollo de aplicaciones móviles",
    "Sistema de diseño y UI toolkits",
    "Wireframing y Diseño UX/UI",
    "Carga masiva de productos en e-commerce",
  ];

  const eventosItems = [
    "Cobertura de eventos",
    "Actividades en punto de venta",
    "Experiencias personalizadas",
    "Eventos Internos",
  ];

  return (
    <div>
      <div className="my-5">
      <BloqueToggle
        id="marketingDigital"
        titulo="MARKETING DIGITAL"
        items={marketingDigitalItems}
        openBlock={openBlock}
        setOpenBlock={setOpenBlock}
      />
      </div>
      <div className="my-5 py-3">
      <BloqueToggle
        id="growthPauta"
        titulo="GROWTH Y PAUTA PUBLICITARIA"
        items={growthItems}
        openBlock={openBlock}
        setOpenBlock={setOpenBlock}
      />
      </div>
      <div className="my-5 py-3">
      <BloqueToggle
        id="branding"
        titulo="BRANDING"
        items={brandingItems}
        openBlock={openBlock}
        setOpenBlock={setOpenBlock}
      />
      </div>
      <div className="my-5 py-3">
      <BloqueToggle
        id="desarrolloWeb"
        titulo="DESARROLLO WEB"
        items={desarrolloWebItems}
        openBlock={openBlock}
        setOpenBlock={setOpenBlock}
      />
      </div>
      <div className="my-5 py-3">
      <BloqueToggle
        id="eventos"
        titulo="EVENTOS"
        items={eventosItems}
        openBlock={openBlock}
        setOpenBlock={setOpenBlock}
      />
      </div>
    </div>
  );
};
// Componente BloqueToggle
export const BloqueToggle = ({ id, titulo, items, openBlock, setOpenBlock }) => {
  const handleToggle = () => {
    // Si el bloque actual está abierto, lo cerramos, de lo contrario lo abrimos
    setOpenBlock(openBlock === id ? null : id);
  };

  return (
    <div className="m_text_secondary ">
      <h5
        onClick={handleToggle}
        className={openBlock === id ? "m_text_orange m_bl fs-1 ma_line_orange" : "m_text_secondary m_bl ma_line_servi fs-1"} // Cambia el color dependiendo de si está abierto
        style={{
          cursor: "pointer",
        }}
      >
        {titulo}
      </h5>
      {openBlock === id && (
        <div className="m_text_orange">
          {items.map((item, i) => (
            <p className="m_bl fs-5" key={i}>
              {String(i + 1).padStart(2, "0")} / {item}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

const CardHoverr = ({ title, title2, text1, text2, text3, text4, text5, urlImg }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className="w-100 m_text_secondary my-5"
    >
      <div>
        <h4 className={`m_hs ${isHover ? 'm_text_orange ma_line_orange' : 'ma_line_servi'}`}>
          {title}<br />{title2}
        </h4>
      </div>

      <img
        className={`ma_imgCard_service ${isHover ? 'show' : ''}`}
        src={urlImg}
        alt="imagen"
      />

      <div className={`m_text_orange ma_animacion_all ma_card-content ${isHover ? 'show' : ''}`}>
        {text1 && <p>{text1}</p>}
        {text2 && <p>{text2}</p>}
        {text3 && <p>{text3}</p>}
        {text4 && <p>{text4}</p>}
        {text5 && <p>{text5}</p>}
      </div>
    </div>
  );
};
const CardHover = ({ title, title2, text1, text2, text3, text4, text5, urlImg }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className="w-100 m_text_secondary my-5 position-relative"
    >
      <div>
        <h4 className={`m_hs ${isHover ? "m_text_orange ma_line_orange " : "ma_line_servi"}`}>
          {title}<br />{title2}
        </h4>
      </div>  

      <div className={`m_text_orange ma_animacion_all ma_card-content ${isHover ? 'show' : ''}`}>
        <p>{text1}</p>
        <p>{text2}</p>
        <p>{text3}</p>
        <p>{text4}</p>
        <p>{text5}</p>
      </div>
    </div>
  );
};

